import api from "./axios";

export const listMyTickets = (params = {}) => api.get("/my/tickets", { params });
export const createMyTicket = (payload) => api.post("/my/tickets", payload);
export const getMyTicket = (id) => api.get(`/my/tickets/${id}`);
export const sendMyTicketMessage = (id, message) =>
  api.post(`/my/tickets/${id}/messages`, { message });
